import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { removeIndustry } from "../../service/industryService";
import RolesAdd from "./roles-Add";
import { RouteComponentProps } from "../../models/RouteComponent";
import { rolesRemove, rolesUpdate } from "../../service/rolesService";
import { useNavigate } from "react-router-dom";

export default function RolesView(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [selectedRole, setSelectedRole] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const client_id = props.session.client_id;

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS }
  }

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRole);
    rolesRemove(selectedRole.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRole(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setSelectedRole(row.value);
    // setVisible(true);
    viewSelected(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRole(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await rolesRemove(selectedRole.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Roles Deleted Successfully', life: 3000 });
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const viewSelected = (row: any) => {
    setVisible(true);
  }

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await rolesUpdate({ "active": status }, selectedRole.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Consultant Activated Successfully' : 'Consultant Deactivated Successfully', life: 3000 });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate role?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate role?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }


  const contextItems = () => {
    let objArray = [
      { label: 'View', icon: 'pi pi-fw pi-eye', command: viewSelected },
    ];
    if (selectedRole?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }


  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'access_label',
      header: 'Access',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'created_at',
      header: 'Created At',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false
    },
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Roles
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url={`roles?clientId=${client_id}`} columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRole?.id ? 'Update Role' : 'Add Role'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <RolesAdd setGlobalLoader={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRole?.id} record={selectedRole} setVisible={setVisible} client={client_id} toast={toast} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}